import React from "react";
import BottomCartBar from "../../../components/ui/BottomCartBar";

interface CartFooterProps {
  isMenuStyle: boolean;
  count: number;
  cartTotal: number;
  onGoToCart: () => void;
}

export default function CartFooter({ isMenuStyle, count, cartTotal, onGoToCart }: CartFooterProps) {
  if (isMenuStyle) return null;

  return <BottomCartBar count={count} total={cartTotal} onClick={onGoToCart} />;
}
